import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaButtonDropdown from './VaButtonDropdown.vue'

export const VaButtonDropdown = withConfigTransport(_VaButtonDropdown)

export * from './types'
